import React from 'react';
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

export const PeopleCard = (props) => {

    const sc = props.slice.primary

    const it = props.slice.items

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background;


    return (
        <section className={"bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div className="wrapper">
                <h2 className="mb-16 md:text-center">{sc.entry_title.text}</h2>
                <div className="flex flex-col md:flex-row flex-wrap justify-center gap-8">
                    {it.map((card, index) => {
                        return (
                            <Link key={index} to={card.person.url} className="p-card overflow-hidden">
                                <span>
                                    <span className="relative block bg-person">
                                        <GatsbyImage image={getImage(card.person.document.data.meta_image)} alt={card.person.document.data.body[0].primary.name.text} className="rounded-t-lg" />
                                    </span>
                                    <span className="p-7 block">
                                        <span className="title text-xl font-bold mb-1 pr-6 block leading-tight">{card.person.document.data.body[0].primary.name.text}</span>
                                        <p className="mb-0 leading-snug">{card.person.document.data.body[0].primary.co_title}</p>
                                    </span>
                                </span>
                                <span className="pb-7 pr-7 pl-7 block">
                                    <span className="btn bg-teal">View bio</span>
                                </span>
                            </Link>
                        )
                    })}
                </div>
            </div>
        </section>
    );
}

